// extracted by mini-css-extract-plugin
export var styles = "breadcrumbs-module--styles--4-1De";
export var zzz = "breadcrumbs-module--zzz--1qNnO";